import { createReducer, on, Action } from '@ngrx/store';
import { IComplaincesData } from 'src/app/models/assesment';
import * as Assessment from '../assessment/assessment.action';


export const initialState: IComplaincesData = {};

const reducer = createReducer(
  initialState,
  on(Assessment.SuccessGetAssessmentDetailsApiAction, (state, { assessmentDetails }) => ({ ...state, ...assessmentDetails })),
  on(Assessment.ErrorGetAssessmentDetailsApiAction, (state, error) => ({ ...state, error })),
  on(Assessment.UpdateAssessmentDetailsApiAction, (state, { payload }) => ({ ...state, payload })),
);

export function AssessmentDetailsReducer(state: IComplaincesData | undefined, action: Action) {
  return reducer(state, action);
}
